import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Breadcrumbs, Typography, Tabs, Tab, Tooltip, Fab } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useAuth } from '@contexts/AuthContext';
import Layout from '@components/Layout';
import WorkflowTable from '@components/workflow/WorkflowTable';
import WorkflowCreationDialog from '@components/workflow/WorkflowCreationDialog';

function WorkflowListPage({ type }) {
    const { t } = useTranslation();
    const { isSuperAdmin } = useAuth();
    const navigate = useNavigate();
    const [modalCreateOpen, setModalCreateOpen] = useState(false);

    const handleTabChange = (event, newValue) => {
        navigate(`/workflows/${newValue}`);
    };

    return (
        <Layout withFloatingButton={true}>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
                <Typography>{t('Workflow management')}</Typography>
                <Typography>{type === "custom" ? t('Custom workflows') : t('Templates')}</Typography>
            </Breadcrumbs>
            <Tabs value={type} onChange={handleTabChange}>
                <Tab value="custom" label={t("Custom workflows")} />
                <Tab value="templates" label={t("Templates")} />
            </Tabs>
            <WorkflowTable type={type} />
            {(type === "custom" || isSuperAdmin()) &&
                <Tooltip title={type === "custom" ? t('Create custom workflow') : t('Create workflow template')} 
                    placement="top" arrow>
                    <Fab color="primary" aria-label={type === "custom" ? t('Create custom workflow') : t('Create workflow template')}
                        className="main-fab" sx={{ boxShadow: 6 }}
                        onClick={() => setModalCreateOpen(true)}>
                        <AddIcon />
                    </Fab>
                </Tooltip>
            }

            <WorkflowCreationDialog modalCreateOpen={modalCreateOpen} setModalCreateOpen={setModalCreateOpen} type={type} />
            
        </Layout >
    );
}

export default WorkflowListPage;
